import { Driver, DriversInitialState, Owner } from './drivers.type'

const ownerMock: Owner = {
  id: '',
  companyName: '',
  companyAddress: '',
  email: '',
  taxNumber: '',
  taxPercentage: '',
  orderStartNumber: '',
  tripPrefix: '',
  tripStartNumber: '',
  invoicePrefix: '',
  invoiceStartNumber: '',
  orderPrefix: '',
  deletedAt: '',
  createdAt: '',
  modifiedAt: '',
  outMail: '',
}

export const driverMock: Driver = {
  id: '',
  firstName: '',
  lastName: '',
  phone: '',
  address: '',
  licenseNumber: '',
  dateOfIssue: '',
  expiryDate: '',
  driverReferenceNumber: '',
  sex: '',
  licenseClass: '',
  restrictions: '',
  dateOfBirth: '',
  height: 0,
  typeOfLicense: '',
  province: '',
  owner: ownerMock,
  tractorId: '',
  trailerId: '',
  verified: '',
  createdAt: '',
  modifiedAt: '',
  driverAppStatus: '',
  citizenshipCountry: '',
  fastCardNumber: '',
}

export const initialState: DriversInitialState = {
  selectedDriver: driverMock,
}
